export default __webpack_public_path__ + "static/media/Gluten-Free.820cf78d.svg";